import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EcmMaterialModule, MaterialSeoService } from '@ecm/material';

import { dashboardTranslationFr } from './i18n/fr';

@NgModule({
    imports: [EcmMaterialModule, RouterModule],
    providers: [MaterialSeoService],
})
export class EcmDashboardModule {
    public constructor(translate: TranslateService) {
        translate.setTranslation('fr', dashboardTranslationFr, true);
    }
}
